import React, { useEffect, useState } from "react";
import { Headers, SlimHeaderFullResponsive } from "design-react-kit";
import configuration from "../Utility/config.json";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../Assets/Img/logo.png";
import Repo from "../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

function Header(props) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [isOperator, setIsOperator] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  let location = useLocation();
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;

  const queryParameters =
    "?returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.host +
    props.subfolder +
    entity_url;

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (cookies.user_profile) {
      if (cookies.user_profile.WorkingEntityId) {
        setIsOperator(true);
      }
    }
  }, [cookies]);

  const deleteToken = () => {
    cookies.remove("token_key");
    window.location.href = props.subfolder + "/home";
  };

  const matchMenu = (linkName) => {
    if (
      location.pathname
        .toLowerCase()
        .replace("_", " ")
        .includes(linkName?.toLowerCase())
    ) {
      return true;
    } else if (
      (location.pathname == "/" || location.pathname == "/") &&
      linkName == "Home"
    ) {
      return true;
    }
  };

  const login = () => {
    return (
      <a
        href={auth_url + configuration.AUTH_PATH_LOGIN + queryParameters}
        className="btn btn-danger btn-sm"
        style={{ background: "#e20a16" }}
      >
        Accedi all'area personale
      </a>
    );
  };

  const notify = () => {
    return (
      <>
        <div className="it-horn-wrapper nav-item dropdown">
          <Link
            to="/#"
            className="btn btn-primary btn-icon btn-full"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <span className="rounded-icon">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-horn`} />
              </svg>
            </span>
          </Link>
          <div
            className="dropdown-menu"
            x-placement="bottom-start"
            style={{
              position: "absolute",
              willChange: "transform",
              top: "0px",
              left: "0px",
              transform: "translate3d(0px, 48px, 0px)",
            }}
          >
            <React.Fragment className="p-3">
              <strong> Notifiche </strong>
              <div> caaa</div>
            </React.Fragment>
          </div>
        </div>
      </>
    );
  };

  const logout = () => {
    return (
      <>
        <div className="it-user-wrapper nav-item dropdown">
          <Link
            to="/#"
            className="btn btn-primary btn-icon btn-full"
            data-toggle="dropdown"
            // aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="rounded-icon">
              <svg className="icon icon-primary ml-0">
                <use href={`${iconSprite}#it-user`} />
              </svg>
            </span>
            <span className="d-none d-lg-block">{props.Name} </span>
          </Link>
          <div
            className="dropdown-menu"
            x-placement="bottom-start"
            style={{
              position: "absolute",
              willChange: "transform",
              top: "0px",
              left: "0px",
              transform: "translate3d(0px, 48px, 0px)",
            }}
          >
            <div className="link-list-wrapper">
              <ul className="link-list ">
                {!isOperator && (
                  <li>
                    <Link className="list-item" to="/profilo">
                      <svg className="icon icon-primary">
                        <use xlinkHref={`${iconSprite}#it-user`}></use>
                      </svg>

                      <span className="ml-1">
                        <b>Profilo</b>
                      </span>
                    </Link>
                  </li>
                )}
                <li>
                  <a
                    className="list-item"
                    href={
                      auth_url +
                      configuration.AUTH_PATH_LOGOUT +
                      queryParameters
                    }
                  >
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-external-link`}></use>
                    </svg>

                    <span className="ml-1">
                      <b>Esci</b>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <header className="it-header-wrapper it-header-sticky">
        <div className="it-header-slim-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="it-header-slim-wrapper-content">
                  <a
                    href="https://www.regione.puglia.it/"
                    style={{ fontSize: "14px" }}
                    target="_blank"
                  >
                    Regione Puglia
                  </a>
                  <div className="nav-mobile">
                    <nav aria-label="Navigazione secondaria">
                      <a
                        className="it-opener d-lg-none"
                        data-toggle="collapse"
                        href="#navigazione-header-slim"
                        role="button"
                        aria-expanded="false"
                        aria-controls="navigazione-header-slim"
                      >
                        <span>Regione Puglia</span>
                        <svg className="icon">
                          <use href={`${iconSprite}#it-expand`} />
                        </svg>
                      </a>

                      <div
                        className="link-list-wrapper collapse"
                        id="navigazione-header-slim"
                      >
                        <ul className="link-list">
                          <li>
                            <a
                              className="list-item"
                              href="https://albo.comune.bari.it/"
                              target="_blank"
                              title="Vai alla pagina: Albo pretorio"
                            >
                              Albo pretorio
                            </a>
                          </li>

                          <li>
                            <a
                              className="list-item"
                              href="https://trasparenza.strategicpa.it/comunebari"
                              target="_blank"
                              title="Vai alla pagina: Amministrazione trasparente"
                            >
                              Amministrazione trasparente
                            </a>
                          </li>

                          <li>
                            <a
                              className="list-item"
                              href="https://portaleappalti.comune.bari.it/PortaleAppalti/it/ppgare_bandi_lista.wp"
                              target="_blank"
                              title="Vai alla pagina: Bandi di gara e contratti"
                            >
                              Bandi di gara e contratti
                            </a>
                          </li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                  <div className="it-header-slim-right-zone ">
                    {apiToken && (
                      <>
                        {props.linksEsterni && props.linksEsterni.length < 2 ? (
                          <>
                            <div className="nav-item d-none d-lg-block">
                              {props.linksEsterni &&
                                props.linksEsterni.map((linkObb, index) => (
                                  <span className="linkMenu" key={index}>
                                    <Link to={linkObb.Url}>
                                      {linkObb.Title}
                                    </Link>
                                  </span>
                                ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                    {/* <div className="it-access-top-wrapper mr-2">{notify()}</div> */}
                    <div className="it-access-top-wrapper">
                      {apiToken ? logout() : login()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="it-nav-wrapper">
          <div className="it-header-center-wrapper">
            <div className="container">
              <div className="it-header-center-content-wrapper ">
                <div className="it-brand-wrapper px-0 mx-0">
                  <div className="row">
                    {width < 992 ? (
                      <>
                        <div className="col-2 mt-4">
                          <a>
                            <button
                              className="custom-navbar-toggler"
                              type="button"
                              aria-controls={
                                props.sidebarMenu ? "app-sidebar" : "nav02"
                              }
                              aria-expanded={
                                props.sidebarMenu
                                  ? !!props.sidebarOpen
                                  : false
                              }
                              aria-label="Toggle navigation"
                              data-target={
                                props.sidebarMenu ? undefined : "#nav02"
                              }
                              onClick={
                                props.sidebarMenu
                                  ? (event) => {
                                      event.preventDefault();
                                      event.stopPropagation();
                                      props.onToggleSidebar();
                                    }
                                  : undefined
                              }
                            >
                              <svg className="icon">
                                <use
                                  href={`${iconSprite}#it-burger`}
                                  width="70%"
                                />
                              </svg>
                            </button>
                          </a>
                        </div>
                        <div className="col-10 mt-1">
                          <a href="/Portal">
                            <img
                              src={logo}
                              alt="logo Comune di Bari"
                              style={{
                                width: "82px",
                                height: "82px",
                                marginRight: "16px",
                              }}
                            />
                            <div className="it-brand-text">
                              <h2
                                style={{ display: "inline" }}
                                className="no_toc "
                              >
                                Comune di Bari
                              </h2>
                            </div>
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="col-12 mt-1">
                        <a href="/Portal">
                          <img height="100" width="100" src={logo} alt="logo" />
                          <div className="it-brand-text">
                            <div className="it-brand-title title">
                              {" "}
                              Comune di Bari
                            </div>
                            <div className="it-brand-tagline d-none d-md-block">
                              <strong>Semplícita</strong> Servizi Alla Persona
                            </div>
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!props.sidebarMenu && (
          <nav className="navbar navbar-expand-lg it-header-navbar-wrapper">
            <div className="container">
              <div className="it-header-navbar-wrapper ">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <nav className="navbar navbar-expand-lg has-megamenu">
                        <div
                          className="navbar-collapsable"
                          id="nav02"
                          style={{ display: "none", width: "80%" }}
                        >
                          <div
                            className="overlay"
                            style={{ display: "none" }}
                          ></div>
                          <div className="close-div sr-only">
                            <button className="btn close-menu" type="button">
                              <span className="it-close"></span>close
                            </button>
                          </div>
                          <div className="menu-wrapper">
                            <ul className="navbar-nav">
                              {props.links &&
                                props.links.map((linkObb, index) => (
                                  <li className="nav-item" key={index}>
                                    <Link
                                      {...(matchMenu(linkObb.testo)
                                        ? {
                                            className:
                                              "nav-link active customMenu customLink",
                                          }
                                        : { className: "nav-link customLink" })}
                                      to={linkObb.url}
                                    >
                                      <span style={{ width: "max-content" }}>
                                        {linkObb.testo}{" "}
                                      </span>
                                      <span className="sr-only">current</span>
                                    </Link>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          )}
        </div>
      </header>
    </>
  );
}

export default Header;
export const MemoizedHeader = React.memo(Header);
